<template>
  <div @click.self="selectSlot">
    <div @click.self="selectSlot" class="booked-unmatched-container">
      <div @click.self="selectSlot" class="booked-unmatched-info">
        <ik-image
          loading="lazy"
          :transformation="[{ height: 60, width: 60 }]"
          v-if="bestMatchInfo.metadata && partnerProfileImageURL"
          :src="partnerProfileImageURL"
          class="calendar-profile-icon"
        />
        <div
          v-else
          @click.self="selectSlot"
          class="calendar-profile-icon smallBorder"
        >
          <IconBase
            icon-name="profile"
            iconColor="#333"
            viewBox="0 0 32 32"
            width="100%"
            height="100%"
            strokeWidth="0px"
            ><IconProfileImg
          /></IconBase>
        </div>
        <PreviewButton v-if="bestMatchInfo" :partner="bestMatchInfo" />
        <span @click.self="selectSlot" class="unmatched-title" :style="unmatchedTitleStyle">{{
          partnerDisplayName
        }}</span>
        <!-- <span>{{matchPool ? matchPool[0].matchableID : matchPool}}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from "../../../../components/IconBase";
import IconProfileImg from "../../../../components/SVG/IconProfileImg";
import PreviewButton from "./PreviewButton";

export default {
  name: "UnmatchedPerson",
  props: ["bestMatchInfo", "slotDateTimeMS", "week"],
  mounted() {
    // console.log("matchInfo", this.bestMatchInfo);
  },
  computed: {
    partnerID: function () {
      const matchMeta = this.bestMatchInfo.metadata;
      return matchMeta ? matchMeta.ID : null;
    },
    partnerDisplayName() {
      const matchMeta = this.bestMatchInfo.metadata;
      return matchMeta.displayName;
    },
    partnerProfileImageURL() {
      const matchMeta = this.bestMatchInfo.metadata;
      return matchMeta.profileImageUrl ? matchMeta.profileImageUrl : null;
    },
    matchPool() {
      const pool = this.$store.state.matchPool.matchPoolUsers[this.slotDateTimeMS];
      // console.log("@Unmatched person something changed in the pool: ", pool);
      return pool;
    },
    unmatchedTitleStyle() {
      let styles = "";
      if (this.week) {
        if (this.$windowWidth <= 1401) {
          styles = "max-width: 60px;";
        }
      } else {
        styles = "max-width: 200px;";
      }
      return styles
    }
  },
  components: {
    IconBase,
    // IconProfile,
    IconProfileImg,
    PreviewButton,
  },
  methods: {
    selectSlot() {
      this.$emit("handleSlotSelection", this.slotDateTimeMS);
    },
  },
  watch: {
    matchPool: function(newVal, oldVal) {
      console.log("@MATCH POOLCHANGED :", newVal, oldVal);
    }
  }
};
</script>
